import React from 'react';
import { useParams } from 'react-router';
import {
  DashboardNotAllowedError,
  DashboardNotFoundError,
} from '../../../api/dashboards/dashboard-errors';
import { useGetUserViewCustomDashboardConfig } from '../../../api/dashboards/hooks';
import { BetterLoadingOverlay } from '../BetterLoading';
import { BetterSuspense } from '../BetterSuspense';
import CustomDashboard from './DashboardBase';
import { DashboardId } from './types';

const CustomDashboardWrapperInner = () => {
  const { dashboardId = '', pageNumber } = useParams<{
    dashboardId: DashboardId | undefined;
    pageNumber: string | undefined;
  }>();

  if (!dashboardId) {
    throw new Error(`Couldn't find dashboard id`);
  }
  const dashboardConfig = useGetUserViewCustomDashboardConfig(dashboardId);

  if (dashboardConfig instanceof DashboardNotFoundError) {
    return <div>{dashboardConfig.message}</div>;
  } else if (dashboardConfig instanceof DashboardNotAllowedError) {
    return <div>{dashboardConfig.message}</div>;
  } else {
    return (
      <CustomDashboard
        dashboardConfig={dashboardConfig}
        selectedPageNumber={Number(pageNumber)}
      />
    );
  }
};

const CustomDashboardWrapper = () => {
  return (
    <BetterSuspense
      fallback={
        <BetterLoadingOverlay
          debugString="CustomDashboardWrapper"
          isPending={false}
        />
      }
      wait={0}
      freez={0}
    >
      <CustomDashboardWrapperInner />
    </BetterSuspense>
  );
};

export default CustomDashboardWrapper;
